import request from '@/router/axios';
// 顶部统计
export const dailyPlanStatistics = (row) => {
    return request({
        url: '/api/dispatch-centre/daily-plan-statistics',
        method: 'post',
        data: row
    })
}
//日计划列表
export const dailyPlanPage = (row) => {
    return request({
        url: '/api/dispatch-centre/daily-plan-page',
        method: 'post',
        data: row
    })
}
//详情
export const planDetail = (id,trainNumber) => {
    return request({
        url: '/api/dispatch-centre/plan-detail',
        method: 'get',
        params: {id,trainNumber}
    })
}
//详情
export const getPlanTimeline = (id,businessType) => {
    return request({
        url: '/api/dispatch-centre/plan-timeline',
        method: 'get',
        params: { id,businessType }
    })
}
//车号列表
export const getPlanCars = (id) => {
    return request({
        url: '/api/dispatch-centre/plan-cars/planId',
        method: 'get',
        params: { id }
    })
}